import { FC } from 'react';

interface DayButtonProps {
  label: string;
  value: number;
  isSelected: boolean;
  onClick: (value: number) => void;
}

export const DayButton: FC<DayButtonProps> = ({ label, value, isSelected, onClick }) => {
  return (
    <button
      onClick={() => onClick(value)}
      className={`flex-[0_0_calc((100%-50px)/7)] py-2 px-1 rounded-lg! cursor-pointer text-sm font-medium transition-colors ${
        isSelected
          ? 'bg-(--tertiary-Y300) text-(--neutral-white-NW1000)'
          : 'bg-(--tertiary-Y100) text-neutral-700 hover:bg-(--tertiary-Y200)'
      }`}
    >
      {label}
    </button>
  );
};
